import React from 'react';
import autoBind from 'react-autobind';
import { Input, Col, Row, Button, Select, Card, Divider } from 'antd';
import { SearchOutlined, SettingOutlined } from '@ant-design/icons';
import moment from 'moment';
//
import '../../assets/stylesheets/CommonSearchBar.less';
import AdvancedSearchFilters from './AdvancedSearchFilters';
//
const DEFAULT_FILTERS = [
  { field: 'firstName', operator: 'CO', value: null },
  { field: 'lastName', operator: 'CO', value: null },
  { field: 'email', operator: 'CO', value: null },
];
export default class CommonSearchBar extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      term: '',
      advancedMode: false,
      filters: DEFAULT_FILTERS,
      matchAll: true
    };
  }

  componentDidMount() {
    if (this.props.advancedSearchPayload) {
      const { filters, quantifier } = this.props.advancedSearchPayload;

      const mappedFilters = filters.map((f) => {
        const fieldConfig = this.props.fields.find((field) => field.value === f.field);
        const isDate = fieldConfig?.type === 'date';

        let value = f.value;

        if (isDate) {
          if (Array.isArray(value)) {
            value = value.map((v) => moment(Number(v)));
          } else {
            value = moment(Number(value));
          }
        }

        return {
          field: f.field,
          operator: f.qualifier,
          value,
        };
      });

      this.setState({
        filters: mappedFilters,
        matchAll: quantifier === 'ALL',
        advancedMode: true,
      });
    }
  }

  toggleAdvancedMode() {
    this.setState(prev => {
      const advancedMode = !prev.advancedMode;
      const resetFilters = DEFAULT_FILTERS.map(f => ({ ...f }));

      if (this.props.onToggleAdvancedSearch) {
        this.props.onToggleAdvancedSearch(advancedMode);
      }

      return {
        advancedMode,
        filters: resetFilters,
        matchAll: true
      };
    });
  }


  handleChange = (e) => {
    this.setState({ term: e.target.value });
  };

  mapFiltersToAPIFormat = () => {
    const { filters } = this.state;

    return filters
      .filter((f) => {
        if (!f.field || !f.operator) {
          return false;
        }
        if (f.value === null || f.value === undefined) {
          return false;
        }
        if (typeof f.value === 'string' && f.value.trim() === '') {
          return false;
        }
        if (Array.isArray(f.value)) {
          const nonNullValues = f.value.filter(v => v !== null && v !== undefined);
          return nonNullValues.length > 0;
        }
        return true;
      })
      .map((f) => {
        let value = f.value;
        if (f.operator === 'BE' && Array.isArray(value)) {
          value = value.map((d) => d?.valueOf?.().toString() ?? d);
        } else if (value?.valueOf) {
          value = value.valueOf().toString();
        }
        return {
          field: f.field,
          qualifier: f.operator,
          value: Array.isArray(value) ? value : [value],
        };
      });
  };

  handleSearch() {
    const { term, matchAll, advancedMode } = this.state;

    this.props.handleSearch(term);

    if (this.props.advancedSearch && advancedMode && this.props.onAdvancedSearchChange) {
      const advancedFilters = this.mapFiltersToAPIFormat();
      const quantifier = matchAll ? 'ALL' : 'ANY';

      this.props.onAdvancedSearchChange({ filters: advancedFilters, quantifier });
    }
  }

  render() {
    const disabled = !this.props.alwaysEnabled && !(this.state.term && this.state.term.length > 0);
    const { advancedMode, filters, matchAll } = this.state;

    return (
      <>
        {this.props.advancedSearch && advancedMode ? (
          <Card
            style={{
              marginTop: 16,
              width: '100%',
              maxWidth: 768,
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
              borderRadius: 8,
              padding: 12,
            }}
          >
            <AdvancedSearchFilters
              fields={this.props.fields}
              initialFilters={filters}
              initialMatchAll={matchAll}
              onChange={(newFilters, newMatchAll) => {
                this.setState({
                  filters: newFilters,
                  matchAll: newMatchAll,
                });
              }}
            />
            <Row justify="end" type="flex" style={{ marginTop: 24 }}>
              <Col style={{ display: 'flex', gap: 8 }}>
                <Button
                  className="usersSearchBarButton"
                  type="primary"
                  disabled={disabled || this.props.disabled}
                  onClick={this.handleSearch}
                >
                  Search
                </Button>

                {this.props.advancedSearch && (
                  <Button
                    icon={<SettingOutlined />}
                    onClick={this.toggleAdvancedMode}
                    title="Advanced Search"
                  />
                )}
              </Col>
            </Row>
          </Card>

        ) : (
          <>
            <Row justify="start" align="middle" type="flex" className="usersSearchBar">
              <Col span={2}>
                <SearchOutlined className="usersSearchBarIcon" />
              </Col>
              <Col span={12}>
                <Input
                  className="usersSearchBarInput"
                  defaultValue={this.props.defaultValue || ''}
                  placeholder="Search.."
                  onChange={this.handleChange}
                  onPressEnter={this.handleSearch}
                />
              </Col>
            </Row>

            <Row justify="end" type="flex" className="usersSearchBarButtonRow">
              <div style={{ display: 'flex', gap: 4 }}>
                <Col className="usersSearchBarButtonColumn">
                  <Button
                    className="usersSearchBarButton"
                    type="primary"
                    disabled={disabled || this.props.disabled}
                    onClick={this.handleSearch}
                  >
                    Search
                  </Button>
                </Col>
                {this.props.advancedSearch && (
                  <Col>
                    <Button
                      icon={<SettingOutlined />}
                      onClick={this.toggleAdvancedMode}
                      title="Advanced Search"
                    />
                  </Col>
                )}
              </div>
            </Row>
          </>
        )}
      </>
    );
  }
}
